import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

import moment from "moment";
import CollectionOverride from "components/CollectionOverride";



export default class LegalEntities extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Legal_Entities_Trustees._name, API.RequestType.READ_ALL);
		super(props, model);
	}

	// FIXME: creates function on every render
	removeCustomer = (pkey, binary_id) => () => {
		this.setState({loading: true});

		let customerModel = new API.BuildClass(Types.Legal_Entities_Trustees._name, API.RequestType.READ);
		customerModel.parent = this.props.parent;

		customerModel.object.pkey = pkey;
		customerModel.object.binary_id = binary_id;

		customerModel.submit(null, API.RequestType.DELETE).then(() => {
			this.setState({loading: false});
			this.props.reloadPage();
		}).catch(() => {
			this.setState({loading: false});
		});
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Name",
				accessor: "pkey",
				Cell: props => <Link
					to={"/customers/" + props.original.binary_id + '-' + props.value}>{props.original.name_first} {props.original.name_last}</Link>
			},
			{
				Header: "Phone Number",
				id: "phone",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.customer_numberss && obj.customer_numberss.length > 0 && obj.customer_numberss[0].number) ? obj.customer_numberss[0].number : '-'
			},
			{
				Header: "Email",
				id: "email",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.customer_emailss && obj.customer_emailss.length > 0 && obj.customer_emailss[0].email) ? obj.customer_emailss[0].email : '-'
			},
			{
				Header: "Address",
				id: "street_1",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.customer_addressess && obj.customer_addressess.length > 0 && obj.customer_addressess[0].street_1) ? obj.customer_addressess[0].street_1 + ' ' + obj.customer_addressess[0].city + ', ' + obj.customer_addressess[0].state + ' ' + obj.customer_addressess[0].zip : '-'
			},
			{
				Header: "DOB",
				id: "birth_date",
				width: 100,
				/** @param {Customers_Object} obj */
				accessor: obj => {
					return obj.birth_date ? moment(obj.birth_date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={`/customers/${props.original._id}`}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<i className={"fa fa-pencil"}/></Button>
							</Link>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Button
								onClick={this.removeCustomer(props.original.pkey, props.original.binary_id)}
								color="danger"
								size="sm"
								block={true}
							>
								<i className="fa fa-trash"/>
							</Button>
						</span>
					);
				}
			},

		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Legal Entities', "")}
							{this.renderHeaderRight("Legal Entities", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
